export const emailStatus = {
    DRAFT: 0,
    SENDING: 1,
    SCHEDULED: 2,
    SENT: 3,
    FAILED: 4,
};

export const groupIemStatus = {
    TODO: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
};

export const groupIemStatusMap = {
    0: {
        label: 'To Do',
        color: 'error',
    },
    1: {
        label: 'In Progress',
        color: 'warning',
    },
    2: {
        label: 'Completed',
        color: 'success',
    },
};
